'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAll = exports.load = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scriptsStore = {};
var head = __CLIENT__ && document.getElementsByTagName('head')[0];

var noop = function noop() {};
var loadScript = function loadScript(path) {
  return new _promise2.default(function (res) {
    if (!head) {
      return;
    }
    var script = document.createElement('script');
    script.src = path;
    script.addEventListener('load', res);
    head.appendChild(script);
    // eslint-disable-next-line no-console
  }).catch(function (error) {
    return console.error('Failed to load path [' + path + ']: ' + error);
  });
};

var load = exports.load = function load(path) {
  return scriptsStore[path] || (scriptsStore[path] = loadScript(path));
};

var loadAll = exports.loadAll = function loadAll(list, callback) {
  return _promise2.default.all(list.map(load)).then(callback || noop);
};

exports.default = load;